import { useSelector } from 'react-redux';
import useIsPartnerStaff from './useIsPartnerStaff';
import { FeatureFlags } from '../../services/exports/Constants';

/**
 * Whether this user gets the self-serve (PLG) partner onboarding flow — the
 * standalone "New restaurant" page plus the onboarding wizard — instead of the
 * classic Add-Company modal and Get Started stepper.
 *
 * Two conditions, both required:
 *  - the audience is partner staff (`useIsPartnerStaff`: a partner provider's
 *    non-store manager), and
 *  - their service provider has the `plg_onboarding` feature flag enabled.
 *
 * The flag defaults to off server-side, so partners already on the platform keep
 * the classic flow until a super admin switches them over; every newly created
 * partner gets it enabled automatically.
 */
export default function usePlgOnboarding() {
  const isPartnerStaff = useIsPartnerStaff();
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const enabled = (serviceProvider?.enabled_feature_flags ?? []).includes(FeatureFlags.PlgOnboarding);

  return isPartnerStaff && enabled;
}
